import React from 'react';
import { WorkPageLayout } from '../Layout';
import styles from './Secure.module.scss';

export const SecureStepOne = () => (
  <WorkPageLayout
    leftContent={
      <div className={styles.secureLeftSection}>
        <span className={styles.secureStepLeft_1}>Secure Data with</span>
        <span className={styles.secureStepLeft_2}>FCE</span>
        <span className={styles.secureStepLeft_3}>Blockchain</span>
        <span className={styles.secureStepLeft_4}>and</span>
        <span className={styles.secureStepLeft_5}>Tokenization</span>
      </div>
    }
    rightContent={
      <div className={styles.secureStepContentWrapper}>
        <p>
          The best way to store data securely is to keep it on a distributed ledger. Blockchain
          technology protects data from unauthorized changes and deletion. You can rely on the
          authenticity of the data certified by the blockchain. We’ve developed an environmentally
          friendly mining system. Our blockchain does not waste energy and resources, but works just
          as efficiently as traditional mining.
        </p>
      </div>
    }
  />
);
